














import { Component, Vue, Prop } from 'vue-property-decorator';

export enum CardinalDirection {
  Right = 'right',
  Down = 'down',
  Left = 'left',
  Up = 'up',
}

@Component
export default class ArrowIcon extends Vue {
  @Prop({ type: String, default: CardinalDirection.Right }) private direction!: CardinalDirection;
  @Prop({ type: String, default: 'black' })
  private color!: string;

  private get rotation(): string {
    const directions = Object.values(CardinalDirection);

    if (!directions.includes(this.direction)) {
      throw new Error(`${this.direction} is not a valid icon direction.`);
    }

    const degrees = directions.indexOf(this.direction) * 90;

    return `rotate(${degrees} 8 8)`;
  }
}
